import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import {
  ContentTemplate,
  Progress,
  TABLE_INITIAL_STATE,
  TitleHeader,
  UPDATE_PAGE,
  UPDATE_SIZE,
  useDataTable
} from 'web-library';
import { useGetJobStatusReportName } from '../../api-refactored/job-status-report/useGetJobStatusReportName';
import { DropDownItem, jobNameMappingToSelect, useAPIDropdown } from '../../hooks/dropdown';
import { JobReportFilters } from '../../models/JobName';
import JobStatusReportListDetail from '../../modules/admin/components/JobStatusReport/JobStatusReportListDetail';
import JobStatusReportSearchForm from '../../modules/admin/components/JobStatusReport/JobStatusReportSearchForm';

const useRawFilters = () => {
  const { data, isFetching } = useGetJobStatusReportName({});

  const jobNames = useAPIDropdown(() => ({ data }), true, jobNameMappingToSelect);

  return { jobNames: jobNames.functionCode as DropDownItem[], isFetching };
};

const JobStatusReport = () => {
  const { state: tableViewState } = useLocation<any>();
  const { t } = useTranslation();
  const { jobNames, isFetching } = useRawFilters();
  const [jobFilters, setJobFilters] = useState<JobReportFilters>(
    tableViewState?.jobKey && {
      jobKey: tableViewState.jobKey,
      dates: tableViewState.dates
    }
  );

  const {
    state,
    dispatch: tableDispatch,
    tOptions,
    selectionToolbar
  } = useDataTable({
    ...TABLE_INITIAL_STATE,
    size: tableViewState?.size || 20,
    page: tableViewState?.page || 0,
    search: tableViewState?.search || '',
    sortColumn: 'syncAttemptDate',
    order: 'desc',
    filters: tableViewState?.filters || {},
  });

  const onConfirmFilters = useCallback(
    (filters: JobReportFilters) => {
      setJobFilters(filters);
      tableDispatch({ type: UPDATE_PAGE, payload: 0 });
      tableDispatch({ type: UPDATE_SIZE, payload: 20 });
    },
    [tableDispatch]
  );

  if (isFetching) {
    return (
      <ContentTemplate transparent>
        <Progress color="secondary" />
      </ContentTemplate>
    );
  }

  return (
    <>
      <TitleHeader title={t('admin->>JobStatusReport.Title')} />
      <JobStatusReportSearchForm
        initialFilters={jobFilters}
        jobNameOptions={jobNames}
        onConfirmFilters={onConfirmFilters}
      />
      {jobFilters && (
        <JobStatusReportListDetail
          state={state}
          tableDispatch={tableDispatch}
          tOptions={tOptions}
          selectionToolbar={selectionToolbar}
          jobFilters={jobFilters}
        />
      )}
    </>
  );
};

export default JobStatusReport;
